module.exports = __webpack_public_path__ + "img/0Q3A7250_P_L_Black.2263ec8a.jpg";